// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","591":"6821c2ad","974":"c24238ed"}[chunkId] + ".chunk.js";
};